import { Video, RotateCcw, FileText, Lock } from "lucide-react";
import { Reveal, MaskText, Eyebrow } from "@/components/motion";
import { CtaButton } from "@/components/CtaButton";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const ITEMS = [
  { icon: Video, t: "Le 2 serate live su Zoom", d: "25 e 26 novembre con Valentina e Renata, con domande in diretta" },
  { icon: RotateCcw, t: "Replay per 30 giorni", d: "Riguardi le serate quando vuoi, anche con il tuo staff" },
  { icon: FileText, t: "PDF \"Protocollo viso Super Glow\"", d: "Un protocollo viso veloce da fare subito in cabina, per un effetto glow immediato" },
];

export const Offer = () => (
  <section id="offerta" className="section border-t border-line" data-testid="offer-section">
    <div className="wrap">
      <Eyebrow>L'iscrizione</Eyebrow>
      <MaskText className="h2 mt-6" lines={["Cosa ricevi", <em className="gold-text">con l'iscrizione</em>]} />
      <div className="mt-14 grid gap-5 lg:grid-cols-[1.3fr_0.7fr]">
        <div className="grid gap-4">
          {ITEMS.map(({ icon: Icon, t, d }, i) => (
            <Reveal key={t} delay={i * 0.08}>
              <div className="card-lux flex gap-6 p-6 sm:p-7">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-gold/40 text-gold"><Icon className="h-5 w-5" strokeWidth={1.5} /></span>
                <div>
                  <b className="font-serif text-2xl font-semibold text-cream">{t}</b>
                  <p className="mt-1 text-sm leading-relaxed text-sand">{d}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.15} className="h-full">
          <div className="relative flex h-full flex-col items-center justify-center overflow-hidden rounded-2xl border border-gold/50 bg-[radial-gradient(100%_80%_at_50%_0%,rgba(199,154,75,0.25),#120e08_70%)] p-9 text-center" data-testid="price-box">
            <small className="text-[11px] font-semibold uppercase tracking-[0.28em] text-gold">Iscrizione</small>
            <div className="gold-text mt-3 font-serif text-8xl font-semibold leading-none" data-testid="price-amount">€27</div>
            <span className="mt-3 text-sm text-sand">+ IVA (€32,94) · fattura al tuo centro</span>
            <CtaButton testid="offer-cta-btn" className="mt-8 w-full" />
            <em className="mt-4 flex items-center gap-2 text-xs not-italic text-sand"><Lock className="h-3.5 w-3.5" /> Pagamento sicuro con carta</em>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

const FAQS = [
  ["Quanto costa?", "€27 + IVA (€32,94 in totale), con fattura intestata al tuo centro. Comprende le 2 serate live, il replay per 30 giorni e il PDF \"Protocollo viso Super Glow\"."],
  ["Perché chiedete la Partita IVA?", "Per emettere la fattura al tuo centro. E perché il workshop è riservato alle titolari."],
  ["Dove si svolge?", "Online su Zoom. Ricevi il link su WhatsApp ed email, e un promemoria prima di ogni serata."],
  ["Ci sarà la registrazione?", "Sì. Il replay delle 2 serate resta disponibile per 30 giorni per tutte le iscritte."],
  ["Mostrerete i protocolli passo per passo?", "No. Vedrai i risultati e cosa fa ogni protocollo: i passaggi tecnici sono formazione privata dei nostri centri. L'unico protocollo che ricevi è il Super Glow, nel PDF in regalo."],
  ["Sono una dipendente, posso iscrivermi?", "No, il workshop è riservato alle titolari. Inoltra questa pagina alla tua titolare: si iscrive lei e può seguirlo insieme al suo staff."],
  ["Perché chiedete tanti dati?", "Perché i posti sono limitati e riservati alle titolari. Verifichiamo ogni iscrizione: con dati falsi o incompleti il link Zoom non viene inviato."],
];

export const Faq = () => (
  <section className="section border-t border-line bg-ink2" data-testid="faq-section">
    <div className="wrap grid gap-12 lg:grid-cols-[0.8fr_1.2fr]">
      <div>
        <Eyebrow>Domande frequenti</Eyebrow>
        <MaskText className="h2 mt-6" lines={["Prima di", <em className="gold-text">iscriverti</em>]} />
      </div>
      <Reveal>
        <Accordion type="single" collapsible className="border-t border-line">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={q} value={`f${i}`} className="border-line" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="py-6 text-left font-serif text-2xl font-semibold text-cream hover:text-gold-light hover:no-underline [&>svg]:text-gold" data-testid={`faq-trigger-${i}`}>
                {q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-[15px] leading-relaxed text-sand">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export const Closing = () => (
  <section className="relative overflow-hidden border-t border-line px-5 py-28 text-center sm:px-8 md:py-40" data-testid="closing-section">
    <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(50%_60%_at_50%_100%,rgba(199,154,75,0.22),transparent_70%)]" />
    <MaskText className="relative mx-auto max-w-4xl text-5xl leading-[1] text-cream sm:text-6xl lg:text-7xl" lines={[<span className="gold-text">Il 25 e 26 novembre</span>, "le porte del Natural", <em>Anti-Age sono aperte.</em>]} />
    <Reveal className="relative mt-12"><CtaButton testid="closing-cta-btn" /></Reveal>
  </section>
);
